// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__KHjCE","egplayaelement0a":"gallery_egplayaelement0a__MjcN5","titleLink":"gallery_titleLink__85mXh","arrow":"gallery_arrow__zkeaB"};